import { useServiceContext } from "@/contexts/ServiceContext";

export const useHotelServiceFiltering = (hotelId: string) => {
  const { filters, actions, computed, useServices } = useServiceContext();

  const servicesQuery = useServices(
    hotelId,
    filters.currentPage,
    computed.limit,
    computed.apiFilters,
  );

  const servicesData = servicesQuery.data || { data: [], total: 0 };
  const services = servicesData.data || [];
  const totalPages = Math.ceil((servicesData.total || 0) / computed.limit);
  const priceRange = servicesQuery.data?.priceRange;

  return {
    services,
    priceRange,
    totalPages,
    isLoading: servicesQuery.isLoading,
    error: servicesQuery.error,

    filters,
    actions,
    computed,

    pagination: {
      currentPage: filters.currentPage,
      totalPages,
      hasNextPage: filters.currentPage < totalPages,
      hasPrevPage: filters.currentPage > 1,
      goToNextPage: () => {
        if (filters.currentPage < totalPages) {
          actions.setCurrentPage(filters.currentPage + 1);
        }
      },
      goToPrevPage: () => {
        if (filters.currentPage > 1) {
          actions.setCurrentPage(filters.currentPage - 1);
        }
      },
      goToPage: (page: number) => {
        if (page >= 1 && page <= totalPages) {
          actions.setCurrentPage(page);
        }
      },
    },
  };
};
